var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-profile-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99944 3.95835C6.16181 3.95835 5.48277 4.63739 5.48277 5.47502C5.48277 6.31265 6.16181 6.99169 6.99944 6.99169C7.83707 6.99169 8.5161 6.31265 8.5161 5.47502C8.5161 4.63739 7.83707 3.95835 6.99944 3.95835ZM4.3161 5.47502C4.3161 3.99306 5.51747 2.79169 6.99944 2.79169C8.4814 2.79169 9.68277 3.99306 9.68277 5.47502C9.68277 6.95698 8.4814 8.15835 6.99944 8.15835C5.51747 8.15835 4.3161 6.95698 4.3161 5.47502ZM1.3878 11.8251C2.30571 10.294 4.2411 9.36947 6.99944 9.36947C9.75777 9.36947 11.6932 10.294 12.6111 11.8251C12.7767 12.1014 12.687 12.4597 12.4107 12.6253C12.1344 12.791 11.7761 12.7013 11.6105 12.425C10.9821 11.3768 9.52843 10.5361 6.99944 10.5361C4.47044 10.5361 3.01682 11.3768 2.38842 12.425C2.22276 12.7013 1.86447 12.791 1.58816 12.6253C1.31185 12.4597 1.22214 12.1014 1.3878 11.8251Z",
    fill: "#B6BFCB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserProfile);
export default __webpack_public_path__ + "static/media/ic-user-profile.8a5d8c7313f317d2335558704bd791f1.svg";
export { ForwardRef as ReactComponent };